import React, { Component } from "react";
import AntdCheckbox, {
  CheckboxProps,
  CheckboxGroupProps
} from "antd/lib/checkbox";
import PagePoint from "../page-point/pagePointEnhanced";
import { ConfigConsumer, ConfigConsumerEProps } from "../config-provider";
import "antd/lib/checkbox/style";

const { Group: AntdCheckboxGroup } = AntdCheckbox;

class Checkbox extends Component<CheckboxProps> {
  static Group: typeof CheckboxGroup;

  render() {
    const { children } = this.props;
    return (
      <ConfigConsumer>
        {({ pagePoint }: ConfigConsumerEProps) =>
          pagePoint ? (
            <PagePoint
              compType="Checkbox"
              {...this.props}
              render={eventprops => (
                <AntdCheckbox {...this.props} {...eventprops}  data-ui-role='Checkbox'>
                  {children}
                </AntdCheckbox>
              )}
            ></PagePoint>
          ) : (
            <AntdCheckbox {...this.props}>{children}</AntdCheckbox>
          )
        }
      </ConfigConsumer>
    );
  }
}

class CheckboxGroup extends Component<CheckboxGroupProps> {
  render() {
    const { children } = this.props;
    return (
      <ConfigConsumer>
        {({ pagePoint }: ConfigConsumerEProps) =>
          pagePoint ? (
            <PagePoint
              compType="CheckboxGroup"
              {...this.props}
              render={eventprops => (
                <AntdCheckboxGroup {...this.props} {...eventprops} data-ui-role='CheckboxGroup'>
                  {children}
                </AntdCheckboxGroup>
              )}
            ></PagePoint>
          ) : (
            <AntdCheckboxGroup {...this.props}>{children}</AntdCheckboxGroup>
          )
        }
      </ConfigConsumer>
    );
  }
}

Checkbox.Group = CheckboxGroup;
export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/checkbox/index.tsx